import React from 'react';

function Intro(props) {
  const classNames = ['c-intro'];
  if (props.section) classNames.push(`-${props.section}`);
  if (props.size) classNames.push(`-${props.size}`);
  if (props.theme) classNames.push(`-${props.theme}`);

  return (
    <div className={classNames.join(' ')}>
      {props.children}
    </div>
  );
}

Intro.propTypes = {
  size: React.PropTypes.string,
  theme: React.PropTypes.string,
  section: React.PropTypes.string,
  children: React.PropTypes.any
};

export default Intro;



// WEBPACK FOOTER //
// ./app/components/common/Intro.jsx